import axios from 'axios'

import { apiConfig } from 'configs/api.config'

export const API = axios.create(apiConfig)

API.makeRequest = ({ type, requestUrl, isRequestCancelable }) => {
  const source = axios.CancelToken.source()
  const request = API[type](requestUrl, { cancelToken: source.token })

  request.isPending = true

  const wrappedRequest = request.finally(() => {
    request.isPending = false
  })

  // NOTE: Creates closure to get a valid current value
  wrappedRequest.getCancellationData = () => ({
    isPending: request.isPending,
    source,
    isRequestCancelable,
  })

  return wrappedRequest
}
